import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, space, transition } from './neonUtil'
import { DOT_PREFIX } from './constant'

const focusGlow = `0 0 0 1px ${cyan[500]}20, 0 0 4px ${cyan[500]}10 !important`

export default genComponentStyleHook(['DatePicker', 'cyberTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 2,
      background: `${space[800]} !important`,
      borderColor: `${cyan[500]}20 !important`,
      color: `${cyan[100]} !important`,

      '&:hover': {
        borderColor: `${cyan[500]}50 !important`,
      },

      [`&${componentCls}-focused`]: {
        borderColor: `${cyan[500]}80 !important`,
        boxShadow: focusGlow,
      },

      [`${componentCls}-input > input`]: {
        color: `${cyan[100]} !important`,
      },

      [`${componentCls}-input > input::placeholder`]: {
        color: `${cyan[800]} !important`,
      },

      [`${componentCls}-suffix, ${componentCls}-clear`]: {
        color: `${cyan[600]} !important`,
      },

      [`${componentCls}-range-separator`]: {
        color: `${cyan[700]} !important`,
      },
    },
  }
})
